module.exports = ".mat-sort-header-container {\r\n  align-items: center;\r\n}"